export const deliveryNote = `PC Worth offers same day delivery on Metro Manila and nearby areas of
Rizal, Cavite and Bulacan. Express Delivery (Same Day) orders can be placed until 3:00 PM only.`;
